export enum ETypeAction {
  AUTH_AND_REDIRECT = 'authAndRedirect',
  REDIRECT_ONLY = 'redirectOnly',
}
